import React, { useState } from 'react';
import NZCIListItem from '../../Base/NZCIListItem';
import NCZISetupInsuranceCompanyModal from '../NCZISetupInsuranceCompany/NCZISetupInsuranceCompanyModal';
import useTranslation from '../../../../../Hooks/useTranslation';
import { TermItem } from '../../../../../graphql/graphql';
import { NcziSetupSettings } from '../NcziSetupSettings';
import { NCZISetupInsuranceCompanyValues } from '../NCZISetupInsuranceCompany/NCZISetupInsuranceCompany';
import { WorkplaceInsuranceSettings } from '../../../Interfaces/insuranceSettings';

interface Props {
	key: number | string;
	insuranceCompany: TermItem;
	userSettings: NcziSetupSettings | null;
	saveInsuranceSettings: (values: NCZISetupInsuranceCompanyValues) => void;
	workplaceInsurance: WorkplaceInsuranceSettings | null;
}

const NCZISetupInsuranceRow: React.FC<Props> = props => {
	const {
		insuranceCompany,
		userSettings,
		saveInsuranceSettings,
		workplaceInsurance,
	} = props;
	const insuranceSettings =
		userSettings?.insuranceSettings[insuranceCompany.value3 || 'default'] ||
		null;
	const workplaceInsuranceSettings =
		workplaceInsurance?.[insuranceCompany.value3 || 'default'] || null;
	const [isSetupOpen, setIsSetupOpen] = useState<boolean>(false);
	const { t } = useTranslation();

	const handleSaveInsuranceSettings = (
		values: NCZISetupInsuranceCompanyValues,
	) => {
		saveInsuranceSettings(values);
		setIsSetupOpen(false);
	};

	const insuranceTexts = insuranceSettings
		? [
				insuranceSettings.codeDoctor,
				insuranceSettings.codeNZ,
				t('base.shared.identificationNumberLabel') +
					': ' +
					(insuranceSettings.companyIdentificationNumber || ''),
		  ]
		: [];

	return (
		<div>
			<NZCIListItem
				title={insuranceCompany.value2 || ''}
				value={
					workplaceInsuranceSettings?.companyIdentificationNumber
						? t('component.nczi.setup.workplaceInsuranceUsed')
						: insuranceSettings
						? insuranceTexts.join(', ')
						: 'Nenastaveno'
				}
				button={{
					title: 'component.nczi.setup.startSetup',
					onClick: () => setIsSetupOpen(true),
				}}
				icon={
					insuranceSettings
						? '/dist/icons/v2/check-green.svg'
						: '/dist/icons/alert-red.svg'
				}
			/>
			<NCZISetupInsuranceCompanyModal
				isOpen={isSetupOpen}
				onClose={() => setIsSetupOpen(false)}
				onSubmit={handleSaveInsuranceSettings}
				insuranceCompany={insuranceCompany}
				currentSettings={insuranceSettings}
			/>
		</div>
	);
};

export default NCZISetupInsuranceRow;
